import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get_po_backlog_state } from '../../../../redux/po_backlog/backlog.selector';
import NonPaginatedDataGrid from '../../../../common/components/Table/NonPaginatedDataGrid';
import SnackbarWithMessage from '../../../../common/components/Snackbars/SnackbarWithMessage';
import { Box } from '@mui/material';
import { FileUploaderRipik } from '../FileUploaderRipik';
import axiosInstance from '../../../../http-common';
import { load_po_from_backend } from '../../../../redux/po_backlog/po.action';

const OpenPODataGrid = ({ category, hidden_fields = [] }) => {
  const state = useSelector(get_po_backlog_state);
  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [file, set_file] = useState(null);
  const dispatch = useDispatch();

  // to upload po data
  const handle_file_upload = async (uploaded_file) => {
    console.log(uploaded_file);
    try {
      const data = new FormData();
      data.append("excel_file", uploaded_file);
      console.log([...data.entries()]);
      const response = await axiosInstance.post(`/v1/qc/upload_open_po/${category}/`, data, {
        "headers": {
          "Content-Type": "multipart/form-data"
        }
      });
      const result = response.data;
      // console.log({ result });
      if (result.status === "error") {
        set_open_snackbar_with_message({
          message: result.message,
          open: true,
          severity: "error"
        });
      }
      else if (result.status === "success") {
        set_open_snackbar_with_message({
          message: `Data uploaded successfully! Loading the new ${category} data now`,
          open: true,
          severity: "success"
        });
        dispatch(load_po_from_backend(state));
      }
    } catch (error) {
      console.log({ error });
    }
  };
  // console.log({ po: state.po });
  const getRowClassName = (params) => {
    if (params.row.expected_delivery_date_by_ip_qa && new Date(params.row.expected_delivery_date_by_ip_qa).getTime() < new Date().getTime()) {
      return 'bg-red-200 hover:bg-red-300'; // Apply this class for completed rows
    }
    if (params.row.expected_delivery_date_by_production && new Date(params.row.expected_delivery_date_by_production).getTime() < new Date().getTime()) {
      return 'bg-red-200 hover:bg-red-300'; // Apply this class for completed rows
    }
    return '';
  };

  return (
    <div>
      <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
        set_open_snackbar_with_message({
          open: false,
          message: "",
          severity: "info"
        });
      }} />
      <Box className="flex justify-end items-center">
        <FileUploaderRipik file={file} file_update_function={(uploaded_file) => {
          set_file(uploaded_file);
          console.log(uploaded_file);
          handle_file_upload(uploaded_file);
        }} upload_message={`Upload ${category === "CB" ? "In Process" : category} Open Po File Here`} />
      </Box>
      {
        state.po && state.po?.[category]?.table_data &&
        <NonPaginatedDataGrid
          rows={state.po?.[category].table_data || []}
          columns={state.po?.[category].columns}
          initialState={{ pinnedColumns: { right: ['receiving_date_by_qc'] } }}
          columnVisibilityModel={{
            id: false,
            _id: false,
            // expected_delivery_date_by_ip_qa: false,
            // material_type: false,
            // sample_type: false,
            // stp_id: false,
            ...hidden_fields?.reduce((acc, el) => ({
              ...acc,
              [el]: false
            }), {})
          }}
          getRowClassName={getRowClassName}
          sx={

            {
              maxHeight: "550px",

            }
          }
        />
      }
    </div>
  );
};

export default OpenPODataGrid;